import { Component, Input, ViewEncapsulation } from '@angular/core';

@Component({
	selector: 'ac-actions-drawer-item',
	templateUrl: './actions-drawer-item.component.html',
	styleUrls: ['./actions-drawer-item.component.scss'],
	encapsulation: ViewEncapsulation.Emulated
})
export class ActionsDrawerItemComponent {

	@Input() public text: string;
	@Input() public subText: string;
	@Input() public popoutPosition: 'left' | 'right' = 'right';

	public showPopout: boolean = false;


}
